<section
  class="flex min-h-screen flex-col items-center justify-center px-4 py-8 sm:px-6"
  [class]="duringExam() ? 'bg-slate-950/90 backdrop-blur-sm' : 'bg-[#F2F3F6]'"
  [attr.role]="duringExam() ? 'alertdialog' : null"
>
  <div class="flex w-full max-w-sm flex-col items-center rounded-3xl bg-white px-8 py-10 text-center shadow-xl">
    <img [src]="imageEnum.COMPANY_LOGO_BLUE" alt="Charaka" class="h-8 w-8" />

    @if (isSmallScreen()) {
      <img [src]="imageEnum.MONITOR" alt="" class="mt-6 h-12 w-12" />
      <h1 class="heading mt-4">Screen size is too small</h1>
      <p class="sub-paragraph mt-3 text-text-secondary">
        Please use a tablet or laptop to take the exam.
      </p>
    } @else if (isTablet() && duringExam()) {
      <img [src]="imageEnum.ALERT_CIRCLE" alt="" class="mt-6 h-12 w-12" />
      <h1 class="heading mt-4">Portrait mode is not allowed</h1>
      <p class="sub-paragraph mt-3 text-text-secondary">
        Portrait mode is not allowed during the exam. Rotate your tablet back to landscape to continue.
      </p>
      <p class="sub-paragraph mt-3 text-red-600">This has been reported, and the exam timer keeps running.</p>
    } @else if (isTablet()) {
      <svg class="mt-6 h-12 w-12 text-brand-primary" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="6" y="10" width="20" height="28" rx="3" stroke="currentColor" stroke-width="2.5" stroke-dasharray="4 3" opacity="0.35" />
        <rect x="18" y="6" width="28" height="20" rx="3" stroke="currentColor" stroke-width="2.5" fill="none" />
        <path d="M12 30L18 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        <path d="M14 30L18 30" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        <path d="M12 28L12 30" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
      <h1 class="heading mt-4">Please switch to landscape mode</h1>
      <p class="sub-paragraph mt-3 text-text-secondary">
        Rotate your tablet to landscape orientation for the best exam experience.
      </p>
    } @else {
      <img [src]="imageEnum.MONITOR" alt="" class="mt-6 h-12 w-12" />
      <h1 class="heading mt-4">Please use a desktop or laptop</h1>
      <p class="sub-paragraph mt-3 text-text-secondary">
        For the best experience and readability, log in to Charaka Mock Test from a desktop or laptop browser.
      </p>
    }
  </div>
</section>
